module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"viewDetail":"Ver detalhes","sales":"Vendas","totalSales":"Total de vendas","transactions":"Transações","averageTicket":"Ticket médio","averageInstallments":"Parcelamento médio"},"en-US":{"viewDetail":"View details","sales":"Sales","totalSales":"Total sales","transactions":"Transactions","averageTicket":"Average ticket","averageInstallments":"Average installments"}}')
  delete Component.options._Ctor
}
